<div class="app-office-logo">
  <a class="navbar-brand mr-auto app-office-logo__brand" href="/">
    @if (showImageNow$()) {
      @if (image$()) {
        <img id="logo" class="app-office-logo__brand--logo app-office-logo__brand--logo--dynamic" [src]="logoUrl$()" alt="" />
      } @else {
        <img id="logo" class="app-office-logo__brand--logo" src="/Cache/images/viewpoint-logo2.png" alt="" />
      }
      <span class="navbar-brand-text app-office-logo__brand--text">
        {{ portalName$() }}
      </span>
    }
  </a>
</div>
